<template>
  <header class="bg-gray-900 sm:flex sm:items-center sm:justify-between ">
    <div class="flex justify-between px-2 py-2 ">
      <div class="ml-5 text-blue-500">
        <a href="/">
          <app-icon name="cloud" />
        </a>
      </div>
      <div class="flex sm:hidden">
        <button type="button" class="px-2 text-gray-500 hover:text-white focus:outline-none focus:text-white" @click="toggle">
          <svg class="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path v-if="isOpen" fill-rule="evenodd" clip-rule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
            <path v-if="!isOpen" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
          </svg>
        </button>
      </div>
    </div>
    <site-navigation :isOpen="isOpen" />
  </header>
</template>

<script>
import SiteNavigation from "./Navigation";
import AppIcon from "./AppIcon";
export default {
  name: "siteheader",
  components: { SiteNavigation, AppIcon },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
